module.exports = __webpack_public_path__ + "img/eng_1.db67c381.jpg";